const forms = document.querySelectorAll('form');

if (forms && forms.length > 0) {
  forms.forEach(setupForm);
}

function setupForm(forms) {
  if (!forms) return;
  const inputs = forms.querySelectorAll('.form-input, .form-textarea');

  if (inputs && inputs.length > 0) {
    inputs.forEach(input => {
      if (!input) return;
      input.addEventListener('focus', function () {
        const formField = input.closest('.form-field');
        if (formField) {
          formField.classList.add('focused');
          formField.classList.remove('filled');
        }
      });
      input.addEventListener('blur', function () {
        const formField = input.closest('.form-field');
        if (formField) {
          formField.classList.remove('focused');
          if (input.value && input.value.trim() !== '') {
            formField.classList.add('filled');
          } else {
            formField.classList.remove('filled');
          }
        }
      });

      if (document.activeElement !== input) {
        if (input.value && input.value.trim() !== '') {
          const formField = input.closest('.form-field');
          if (formField) {
            formField.classList.add('filled');
          }
        }
      }
    });
  }

  const fields = forms.querySelectorAll('.form-field');

  if (fields && fields.length > 0) {
    fields.forEach(field => {
      if (!field) return;
      const input = field.querySelector('.form-input, .form-textarea');
      if (!input) return;

      const updateFilled = () => {
        if (input.value && input.value.trim() !== '') {
          field.classList.add('filled');
        } else {
          field.classList.remove('filled');
        }
      };

      const observer = new MutationObserver(updateFilled);

      observer.observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });

      input.addEventListener('input', updateFilled);
      input.addEventListener('change', updateFilled);

      updateFilled();
    });
  }

  forms.addEventListener('reset', function() {
    const formFields = forms.querySelectorAll('.form-field');
    if (formFields && formFields.length > 0) {
      formFields.forEach(field => {
        if (field) field.classList.remove('filled');
      });
    }
  });
}
